import { ACCOUNT_SECTIONS, DEFAULT_ACCOUNT_SECTION } from '@/app/routes';

export const COMPANY_PROFILE_FIELDS = Object.freeze({
  companyName: 'companyName',
  companyId: 'companyId',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  country: 'country',
  zipCode: 'zipCode',
});

export const REQUIRED_COMPANY_PROFILE_FIELDS = Object.freeze([
  COMPANY_PROFILE_FIELDS.companyName,
  COMPANY_PROFILE_FIELDS.companyId,
  COMPANY_PROFILE_FIELDS.addressLine1,
  COMPANY_PROFILE_FIELDS.city,
  COMPANY_PROFILE_FIELDS.country,
  COMPANY_PROFILE_FIELDS.zipCode,
]);

export const COMPANY_ID_MAX_LENGTH = 20;

export const EMPTY_COMPANY_PROFILE_FORM = Object.freeze(
  Object.fromEntries(Object.values(COMPANY_PROFILE_FIELDS).map((field) => [field, ''])),
);

const SECTION_TABS = Object.freeze([
  { section: ACCOUNT_SECTIONS.companyProfile, labelKey: 'ACCOUNT_SETUP_TAB_COMPANY_PROFILE' },
  {
    section: ACCOUNT_SECTIONS.companyStructure,
    labelKey: 'ACCOUNT_SETUP_TAB_COMPANY_STRUCTURE',
  },
  {
    section: ACCOUNT_SECTIONS.massBalancePeriod,
    labelKey: 'ACCOUNT_SETUP_TAB_MASS_BALANCE_PERIOD',
  },
  { section: ACCOUNT_SECTIONS.materials, labelKey: 'ACCOUNT_SETUP_TAB_MATERIALS' },
  {
    section: ACCOUNT_SECTIONS.systemSettings,
    labelKey: 'ACCOUNT_SETUP_TAB_SYSTEM_SETTINGS',
    built: false,
  },
]);

export const STRUCTURE_TABS = Object.freeze({
  sites: 'sites',
  backToBackAccounts: 'backToBackAccounts',
  storageUnits: 'storageUnits',
});

export const DEFAULT_STRUCTURE_TAB = STRUCTURE_TABS.sites;

const STRUCTURE_TAB_LIST = Object.freeze([
  { tab: STRUCTURE_TABS.sites, labelKey: 'ACCOUNT_SETUP_STRUCTURE_TAB_SITES' },
  {
    tab: STRUCTURE_TABS.backToBackAccounts,
    labelKey: 'ACCOUNT_SETUP_STRUCTURE_TAB_BACK_TO_BACK',
  },
  {
    tab: STRUCTURE_TABS.storageUnits,
    labelKey: 'ACCOUNT_SETUP_STRUCTURE_TAB_STORAGE_UNITS',
    built: false,
  },
]);

const isBuilt = (tab) => tab.built !== false;

export const buildStructureTabs = (t) =>
  STRUCTURE_TAB_LIST.map((tab) => ({
    value: tab.tab,
    label: t(tab.labelKey),
    disabled: !isBuilt(tab),
  }));

export const buildAccountSetupTabs = (t) =>
  SECTION_TABS.map((tab) => ({
    value: tab.section,
    label: t(tab.labelKey),
    disabled: !isBuilt(tab),
  }));

export const resolveAccountSection = (section) =>
  SECTION_TABS.some((tab) => tab.section === section && isBuilt(tab))
    ? section
    : DEFAULT_ACCOUNT_SECTION;
